/**
 * Smoothly scrolls to an in-page section.
 *
 * Anchor navigation is handled manually rather than by the browser: letting the
 * default `#hash` jump run changes the URL, which in embedded/preview contexts
 * can remount the page and send the visitor back to the top. We prevent the
 * default, scroll ourselves, and never touch history.
 */
export function scrollToSection(
  event: React.MouseEvent<HTMLAnchorElement>,
  href: string,
  onDone?: () => void,
): void {
  if (!href.startsWith('#')) return

  const target = document.querySelector(href)
  if (!target) return

  event.preventDefault()
  onDone?.()

  const run = () => {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    const offset = window.innerWidth >= 1024 ? 84 : 72
    const top = target.getBoundingClientRect().top + window.scrollY - offset
    window.scrollTo({ top, behavior: reduce ? 'auto' : 'smooth' })
  }

  // Give a closing mobile panel a frame to collapse before measuring.
  window.requestAnimationFrame(() => window.setTimeout(run, onDone ? 60 : 0))
}
